import { CarouselInterface } from '../../../shared/UniversalCarousel';
import { ProgressBar } from '../../../shared/ProgressBar';
type DashboardTravelItineraryIntroductionProgressBarProps = {
  totalPages: number;
};
export const DashboardTravelItineraryIntroductionProgressBar = ({
  totalPages
}: DashboardTravelItineraryIntroductionProgressBarProps) => {
  if (totalPages <= 1) return null;
  return <CarouselInterface data-sentry-element="CarouselInterface" data-sentry-component="DashboardTravelItineraryIntroductionProgressBar" data-sentry-source-file="ProgressBar.tsx">
      {({
      visibleIndexes
    }) => {
      const currentPage = (visibleIndexes[0] ?? 0) + 1;
      return <ProgressBar progress={currentPage / totalPages}>
            <span className="text-sm">
              <span className="font-semibold">{currentPage}</span> /{' '}
              {totalPages}
            </span>
          </ProgressBar>;
    }}
    </CarouselInterface>;
};